import { render, staticRenderFns } from "./seatImport.vue?vue&type=template&id=4e8cbd3b&scoped=true&"
import script from "./seatImport.vue?vue&type=script&lang=js&"
export * from "./seatImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8cbd3b",
  null
  
)

export default component.exports